import crawlApi, {
  type CrawlCountArg,
  type CrawlRequestBody
} from './crawlApi';

const externalLinksApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    countCrawlExternalLinks: build.query<unknown, CrawlCountArg>({
      query: ({ job_page, domain_slug }: CrawlCountArg) => ({
        url: '/khazesh/v3/external_links/count',
        method: 'POST',
        body: { job_page, domain_slug }
      })
    }),

    getCrawlExternalLinks: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/external_links/`,
        method: 'POST',
        body: body
      })
    }),

    getChartData: build.query<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/external_links/count_group_of_domain_links`,
        method: 'POST',
        body: body
      })
    })
  })
});

export const {
  useCountCrawlExternalLinksQuery,
  useGetCrawlExternalLinksMutation,
  useGetChartDataQuery
} = externalLinksApi;
export default externalLinksApi;
